export default __webpack_public_path__ + "static/special-conditions-icon-69ea533b1c3abd4fa56c0db0e0fb4546.svg";